import React from 'react';
import "./InsightDetailPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import InsightsDetails from '../../Common/InsightsDetails';
//import {InSights_Detail} from '../../data'


// function App() {
//   return <X07InsightsPageDETAILSTablet {...x07InsightsPageDETAILSTabletData} />;
// }

// export default App;

export default function X07InsightsPageDETAILSTablet(props) {
  // const {
  //   bbmp,
  //   rectangle76,
  //   text245,
  //   text246,
  //   image9,
  //   spanText,
  //   spanText2,
  //   spanText3,
  //   spanText4,
  //   spanText5,
  //   spanText6,
  //   spanText7,
  //   spanText8,
  //   spanText9,
  //   spanText10,
  //   frame144Props,
  //   //footer52Props,
  // } = props;

  return (
    <div className="idpt-container-center-horizontal">
      <div className="idpt-x07-insights-page-details-tablet screen">
        {/* <Frame144 group86Props={frame144Props.group86Props} iconMenuProps={frame144Props.iconMenuProps} /> */}
        <NavBar/>
        <InsightsDetails {...props}/>
        {/* <h1 className="idpt-title idpt-valign-text-middle idpt-typographyheadlineh4-extrabold-24">{bbmp}</h1> */}
        {/* <img className="idpt-rectangle-76" src={rectangle76} /> */}
        {/* <img className="idpt-rectangle-76" src={InSights_Detail.BBMP} /> */}
        {/* <p className="idpt-text-1 idpt-typography-body-smalltext-14-regular">{text245}</p>
        <div className="idpt-text-2 idpt-valign-text-middle idpt-typographyheadlineh4-extrabold-24">{text246}</div> */}
        {/* <img className="idpt-image-9" src={image9} /> */}
        {/* <img className="idpt-image-9" src={InSights_Detail.BbmpPlan} />
        <p className="idpt-text-3 idpt-valign-text-middle idpt-typographybody16-regular"> */}
          {/* <span>
            <span className="idpt-span0 idpt-typographybody16-regular">{spanText}</span>
            <span className="idpt-span idpt-overpass-semi-bold-mahogany-16px">{spanText2}</span>
            <span className="idpt-span idpt-overpass-semi-bold-shark-16px">{spanText3}</span>
            <span className="idpt-span idpt-overpass-semi-bold-silver-16px">{spanText4}</span>
            <span className="idpt-span idpt-overpass-semi-bold-shark-16px">{spanText5}</span>
            <span className="idpt-span idpt-overpass-semi-bold-mahogany-16px">{spanText6}</span>
            <span className="idpt-span idpt-overpass-semi-bold-shark-16px">{spanText7}</span>
            <span className="idpt-span idpt-overpass-semi-bold-silver-16px">{spanText8}</span>
            <span className="idpt-span idpt-overpass-semi-bold-shark-16px">{spanText9}</span>
            <span className="idpt-span idpt-overpass-semi-bold-mahogany-16px">{spanText10}</span>
          </span>
        </p> */}
        {/* <Footer52 {...footer52Props} /> */}
        <Footer />
      </div>
    </div>
  );
}


// function Frame144(props) {
//   const { group86Props, iconMenuProps } = props;

//   return (
//     <div className="idpt-frame-144">
//       <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
//       <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
//     </div>
//   );
// }


// function Group86(props) {
//   const { group85, whiteProps } = props;

//   return (
//     <div className="idpt-group-86">
//       <White src={whiteProps.src} />
//       <img className="idpt-group-85" src={group85} />
//     </div>
//   );
// }


// function White(props) {
//   const { src } = props;

//   return (
//     <div className="idpt-white">
//       <img className="idpt-vector" src={src} />
//     </div>
//   );
// }


// function IconMenu(props) {
//   const { vector2, vector3 } = props;

//   return (
//     <div className="idpt-icon-menu">
//       <img
//         className="idpt-vector-2"
//         src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
//       />
//       <img className="idpt-vector-1" src={vector2} />
//       <img className="idpt-vector-1" src={vector3} />
//     </div>
//   );
// }


// function Footer52(props) {
//   const {
//     group85,
//     place,
//     overlapGroup,
//     vector2,
//     phone,
//     overlapGroup1,
//     vector3,
//     text15,
//     text14,
//     contactWebuildCom,
//     quickLinks,
//     aboutUs,
//     projects,
//     gallery,
//     knowledgeTransfer,
//     blogs,
//     faqs,
//     group872Props,
//   } = props;

//   return (
//     <div className="idpt-footer">
//       <div className="idpt-flex-row-1">
//         <img
//           className="idpt-vector-3"
//           src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
//         />
//         <img className="idpt-group-85-1" src={group85} />
//         <Group872
//           facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
//           facebookAppSymbolProps2={group872Props.facebookAppSymbolProps2}
//           twitterProps={group872Props.twitterProps}
//         />
//       </div>
//       <div className="idpt-flex-row-2">
//         <div className="idpt-group-32">
//           <div className="idpt-place idpt-valign-text-middle idpt-typographyheadlineh5-extrabold-20">{place}</div>
//           <div className="idpt-flex-row-3">
//             <div className="idpt-flex-col">
//               <div className="idpt-map-pin-1">
//                 <div className="idpt-overlap-group" style={{ backgroundImage: `url(${overlapGroup})` }}>
//                   <img className="idpt-vector-4" src={vector2} />
//                 </div>
//               </div>
//               <div className="idpt-phone" style={{ backgroundImage: `url(${phone})` }}></div>
//               <div className="idpt-mail">
//                 <div className="idpt-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
//                   <img className="idpt-vector-5" src={vector3} />
//                 </div>
//               </div>
//             </div>
//             <div className="idpt-flex-col-1">
//               <p className="idpt-text-5 idpt-typography-body-smalltext-14-regular">{text15}</p>
//               <div className="idpt-flex-col-item idpt-valign-text-middle idpt-typography-body-smalltext-14-regular">{text14}</div>
//               <div className="idpt-flex-col-item idpt-valign-text-middle idpt-typography-body-smalltext-14-regular">
//                 {contactWebuildCom}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="idpt-group-147">
//           <div className="idpt-quick-links idpt-valign-text-middle idpt-typographyheadlineh5-extrabold-20">{quickLinks}</div>
//           <div className="idpt-flex-row-4">
//             <div className="idpt-about-us idpt-valign-text-middle idpt-typographybody16-regular">{aboutUs}</div>
//             <div className="idpt-projects idpt-valign-text-middle idpt-typographybody16-regular">{projects}</div>
//           </div>
//           <div className="idpt-flex-row">
//             <div className="idpt-gallery idpt-valign-text-middle idpt-typographybody16-regular">{gallery}</div>
//             <div className="idpt-knowledge-transfer idpt-valign-text-middle idpt-typographybody16-regular">{knowledgeTransfer}</div>
//           </div>
//           <div className="idpt-flex-row">
//             <div className="idpt-blogs idpt-valign-text-middle idpt-typographybody16-regular">{blogs}</div>
//             <div className="idpt-fa-qs idpt-valign-text-middle idpt-typographybody16-regular">{faqs}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


// function Group872(props) {
//   const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

//   return (
//     <div className="idpt-group-87">
//       <FacebookAppSymbol src={facebookAppSymbolProps.src} />
//       <Instagram2 overlapGroup1={facebookAppSymbolProps2.overlapGroup1} vector2={facebookAppSymbolProps2.vector2} />
//       <Twitter src={twitterProps.src} />
//     </div>
//   );
// }


// function FacebookAppSymbol(props) {
//   const { src } = props;

//   return (
//     <div className="idpt-facebook-app-symbol">
//       <img className="idpt-f-1" src={src} />
//     </div>
//   );
// }


// function Instagram2(props) {
//   const { overlapGroup1, vector2 } = props;

//   return (
//     <div className="idpt-instagram">
//       <div className="idpt-overlap-group-1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
//         <img
//           className="idpt-vector-6"
//           src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-18@2x.svg"
//         />
//         <img className="idpt-vector-7" src={vector2} />
//       </div>
//     </div>
//   );
// }


// function Twitter(props) {
//   const { src } = props;

//   return (
//     <div className="idpt-twitter">
//       <img className="idpt-vector-8" src={src} />
//     </div>
//   );
// }

// const whiteData = {
//     src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
// };

// const group86Data = {
//     group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
//     whiteProps: whiteData,
// };

// const iconMenuData = {
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
//     vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
// };

// const frame144Data = {
//     group86Props: group86Data,
//     iconMenuProps: iconMenuData,
// };

// const facebookAppSymbolData = {
//     src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
// };

// const instagram2Data = {
//     overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-215@2x.svg",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-19@2x.svg",
// };

// const twitterData = {
//     src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-157@2x.svg",
// };

// const group872Data = {
//     facebookAppSymbolProps: facebookAppSymbolData,
//     facebookAppSymbolProps2: instagram2Data,
//     twitterProps: twitterData,
// };

// const footer52Data = {
//     group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
//     place: "Contact",
//     overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-20@2x.svg",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-21@2x.svg",
//     phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-212@2x.svg",
//     overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-231@2x.svg",
//     vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-232@2x.svg",
//     text15: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
//     text14: "+91 8976535221, +91 8755645342",
//     contactWebuildCom: "contact@webuild.com",
//     quickLinks: "Quick Links",
//     aboutUs: "About Us",
//     projects: "Projects",
//     gallery: "Gallery",
//     knowledgeTransfer: "Knowledge Transfer",
//     blogs: "Blogs",
//     faqs: "FAQ’s",
//     group872Props: group872Data,
// };

// const x07InsightsPageDETAILSTabletData = {
//     bbmp: "BBMP",
//     rectangle76: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-76-7@1x.png",
//     text245: "The Bruhat Bengaluru Mahanagara Palike or the BBMP is the authority managing the innumerable infrastructure and civic amenities in Greater Bengaluru. Therefore, getting clearance and approval from the BBMP before implementing the building construction is a crucial step. The BBMP authorities have the power to demolish the building already constructed or levy a huge price as a penalty for illegal construction under its jurisdiction.   However, you can be guaranteed that by following the right procedure with the submission of appropriate documents and paying the prescribed fee, the verification will be done by the concerned BBMP authorities and you will have all your documents approved and clearance within a span of 30 days.",
//     text246: "How to submit building plan approval application?",
//     image9: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/image-9-2@1x.png",
//     spanText: <>The application forms for approval can be downloaded from the official website: ___ and submitted online or offline.<br />The choice of forms and the authorized officer to sanction the application is dependent on the size of the building plan. The different forms are attached for your perusal to give you better clarity on the terms and details asked in the set documents.<br />By duly filling in the suitable application form according to your building size and submitting the following original documents along will enable a hassle-free process <br /><br /></>,
//     spanText2: "  Latest BBMP Khata Certificate",
//     spanText3: "   ",
//     spanText4: " |",
//     spanText5: "    ",
//     spanText6: "Latest Khata Extract ",
//     spanText7: "   ",
//     spanText8: "|",
//     spanText9: "   ",
//     spanText10: " Latest Tax Paid Receipt",
//     frame144Props: frame144Data,
//     //footer52Props: footer52Data,
// };

